



















import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';
import PopularArticles from '~/components/partials/SilverEgg/PopularArticles.vue';
import { url } from '~/utils';
import { RecommendItem } from '~/types/common/silverEgg';
import type { ArticleCategory } from '~/types/modules/contents';
import AppLink from '@/components/partials/App/AppLink.vue';

export default defineComponent({
  components: {
    PopularArticles,
    AppLink,
  },
  props: {
    categories: {
      type: Array as PropType<ArticleCategory[]>,
      required: true,
    },
    popularArticles: {
      type: Array as PropType<RecommendItem[]>,
      default: () => [],
    },
    rqid: {
      type: String,
      default: '',
    },
    spec: {
      type: String,
      default: '',
    },
    sortIndex: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    /** カテゴリのリンク */
    const categoryLink = computed(() => {
      return (category?: string) => {
        const path = category ? url('ARTICLE_LIST_CATEGORY', { permalink: category }) : url('ARTICLE_LIST');
        const query = props.sortIndex ? { sortIndex: props.sortIndex.toString() } : undefined;

        return { path, query };
      };
    });

    return { categoryLink };
  },
});
